import React from 'react';
import { FormControl, InputLabel, Select, MenuItem} from "@mui/material";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

interface MuiSelectProps {
  label?: string;
  value: string;
  options: Array<any>;
  onChangeHandler: any;
}

const MuiSelect: React.FC<MuiSelectProps> = ({label, value, options, onChangeHandler}) => {

  return (
    <FormControl fullWidth size="small">
      {label && <InputLabel id="demo-simple-select-label"> {label}  </InputLabel>}
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={value}
        label= {label}
        onChange={(e) => onChangeHandler(e.target.value)}
        IconComponent={KeyboardArrowDownIcon}
      >
        {options.map((o, i) =>  <MenuItem key={i} value={o}>{o}</MenuItem>)}
      </Select>
    </FormControl>
  )
}

export default MuiSelect;
